// extracted by mini-css-extract-plugin
module.exports = {"infoLine":"ContactInfo_infoLine__GOlgS","label":"ContactInfo_label__QfSPJ"};